<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="date"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="date"
        :label="$t('helper.chooseDate')"
        prepend-inner-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        outlined
        hide-details
        dense
        style="max-width: 250px;"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="date"
      no-title
      scrollable
      :locale="locale"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <v-spacer />
      <v-btn
        text
        color="primary"
        @click="menu = false"
      >
        {{ $t('helper.cancel') }}
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="$refs.menu.save(date), $emit('input', date), $emit('changeDate', date)"
      >
        {{ $t('helper.agree') }}
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
  export default {
    data: () => ({
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
    }),
    computed: {
      locale() {
        return this.$i18n.locale;
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.setDefaultValue();
        this.$emit('input', this.date);
      });
    },
    methods: {
      setDefaultValue() {
        this.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>